import { Box, Button, Dialog, Grid, Typography } from "@mui/material";
import { yellow } from "@mui/material/colors";

function ResetConfirmDialog({isOpen, doReturn, doSubmitAndReset, doResetWithoutSubmit, canSubmit}) {

  const handleClickReturn = (_) => {
    doReturn();
  }

  const handleClickSubmitAndReset = (_) => {
    doSubmitAndReset();
  }

  const handleClickResetWithoutSubmit = (_) => {
    doResetWithoutSubmit();
  }

  return (
    <Dialog
      open={isOpen}
    >
      <Box m={2} width={450}>
        <Typography fontSize={20} fontWeight='bold' mb={2}>
          確認
        </Typography>
        <Typography my={2}>
          表示中のCSV読込結果を確定しますか?
        </Typography>
        <Grid container>
          <Grid item xs>
            <Button
              variant="contained"
              color="error"
              onClick={handleClickReturn}
            >
              再取込せず戻る
            </Button>
          </Grid>
          <Grid item xs>
            <Button
              variant="contained"
              onClick={handleClickSubmitAndReset}
              disabled={!canSubmit}
            >
              確定して再取込
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="contained"
              sx={{
                backgroundColor: yellow[500],
                color: "black",
                "&:hover": {
                  backgroundColor: yellow[600],
                }
              }}
              onClick={handleClickResetWithoutSubmit}
            >
              確定せず再取込
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  )
}

export default ResetConfirmDialog;